/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsRight = createReactComponent("outline", "arrows-right", "IconArrowsRight", [["path", { "d": "M21 17l-18 0", "key": "svg-0" }], ["path", { "d": "M18 4l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M21 7l-18 0", "key": "svg-3" }]]);

export { IconArrowsRight as default };
//# sourceMappingURL=IconArrowsRight.mjs.map
